import applyCategoryOperationService from '../services/applyCategoryOperationService';
import setIsApplyingCategoryOperation from '../mutators/setIsApplyingCategoryOperation';
import CategoryOperationType from 'owa-service/lib/contract/CategoryOperationType';

// Delete/rename and then re-enable functionality once the service command is complete
export default async function applyCategoryOperationHelper(
    operation: CategoryOperationType,
    oldCategoryName: string,
    newCategoryName?: string
) {
    await applyCategoryOperationService(operation, oldCategoryName, newCategoryName);
    setIsApplyingCategoryOperation(false);
}
